import '../styles/modalDialog.less';
import $ from 'jquery';
import * as common from '../../../shared/modules/common';
import * as frames from '../../../shared/modules/frames';

var commentStartReplacement = '__UWR_MODAL_DIALOG_COMMENT_START__',
    commentEndReplacement = '__UWR_MODAL_DIALOG_COMMENT_END__',
    extraText = '__UWR_MODAL_DIALOG_EXTRA_TEXT__';

/** EVENTS */

function escEventHandler(event, $popup) {
    if ($popup.data('close-on-esc') && event.keyCode === 27) {
        close();
    }
}

function enterEventHandler(event, $popup) {
    if (event.keyCode === 13) {
        var $submit = $popup.find('.uwr-button-submit');
        if ($submit.length !== 0) {
            $submit.click();
            common.stopPropagation(event);
        }
    }
}

function keyEventHandler(event) {
    var targetFrame = getState().targetFrame;
    $('.uwr-modal-dialog-popup .uwr-modal-dialog', getDocument(targetFrame)).each(function () {
        escEventHandler(event, $(this));
        enterEventHandler(event, $(this));
    });
}

function bindKeyEventHandlers() {
    var targetFrame = getState().targetFrame;
    if (!getState().hasKeyHandlers) {
        $(getDocument(window)).on('keydown', keyEventHandler);
        $(getDocument(targetFrame)).on('keydown', keyEventHandler);
        getState().hasKeyHandlers = true;
    }
}

function unbindKeyEventHandlers() {
    var targetFrame = getState().targetFrame;
    $(getDocument(window)).off('keydown', keyEventHandler);
    $(getDocument(targetFrame)).off('keydown', keyEventHandler);
    getState().hasKeyHandlers = false;
}

function addTopCloseButtonHandler($popup) {
    $popup.find('.uwr-modal-dialog-button-close').each(function () {
        var button = $(this);
        if (button.attr('onclick') === undefined) {
            button.click(function () {
                close();
            });
        }
    });
}

function addTouchHandler($popup, $mask) {
    var origScrollTop,
        origScrollLeft,
        touchstartPageX,
        touchstartPageY;
    $mask.on('touchmove', null, false);
    $popup.on('touchmove', '.uwr-modal-dialog', false);
    $popup.on('touchstart touchend touchcancel touchleave touchmove', '.uwr-modal-dialog-content', function (ev) {
        var touch = ev.originalEvent.targetTouches[0],
            currentTarget = ev.currentTarget,
            deltaX,
            deltaY;
        if (ev.type === 'touchstart') {
            origScrollTop = currentTarget.scrollTop;
            origScrollLeft = currentTarget.scrollLeft;
            touchstartPageX = touch.pageX;
            touchstartPageY = touch.pageY;
        } else if (touch) {
            deltaX = touchstartPageX - touch.pageX;
            deltaY = touchstartPageY - touch.pageY;
            currentTarget.scrollLeft = origScrollLeft + deltaX;
            currentTarget.scrollTop = origScrollTop + deltaY;
        } else {
            origScrollLeft = currentTarget.scrollLeft;
            origScrollTop = currentTarget.scrollTop;
        }
    });
}

function addMouseWheelHandler($popup, $mask) {
    $mask.on('DOMMouseScroll mousewheel', null, false); // ignore mouse wheel events on mask
    // ignore mouse wheel events on popup in general
    $popup.on('DOMMouseScroll mousewheel', '.uwr-modal-dialog', false);
    // keep event from bubbling and overscrolling
    $popup.on('DOMMouseScroll mousewheel', '.uwr-modal-dialog-content', function (ev) {
        var modalDialogContent = this,
            $modalDialogContent = $(modalDialogContent),
            scrollTop = modalDialogContent.scrollTop,
            scrollHeight = modalDialogContent.scrollHeight,
            height = $modalDialogContent.height(),
            originalEvent = ev.originalEvent,
            delta = ev.type === 'DOMMouseScroll' ? originalEvent.detail * -40 : originalEvent.wheelDelta,
            up = delta > 0;

        if (!up && -delta > scrollHeight - height - scrollTop) {
            // Scrolling down, but this will take us past the bottom.
            $modalDialogContent.scrollTop(scrollHeight); // instead of overscrolling
            return common.cancelEvent(ev);
        } else if (up && delta > scrollTop) {
            // Scrolling up, but this will take us past the top.
            $modalDialogContent.scrollTop(0); // instead of overscrolling
            return common.cancelEvent(ev);
        }

        ev.stopPropagation(); // keep event from bubbling in any case
    });
}

function addResizeHandler($popup, $mask) {
    var targetFrame = getState().targetFrame;
    resizeModal($popup, $mask);
    $(targetFrame).resize(function () {
        resizeModal($popup, $mask);
    });
}

function dispatchCustomCloseEvent() {
    var eventTarget = getState().eventTargetElement;
    if (eventTarget) {
        common.dispatchEvent('uwr:modaldialog:close', eventTarget);
    }
}

/** DOM */

function getTargetFrameWithUwr() {
    return frames.getTargetFrameForOverlay({uwrLoaded: true});
}

function getTargetFrameWithoutUwr() {
    return frames.getTargetFrameForOverlay({uwrLoaded: false});
}

function getDocument(frame) {
    return frames.getDocument(frame);
}

function addZIndex($child, zIncrement) {
    var zIndexStr = $child.css('zIndex'),
        zIndexNum = $.isNumeric(zIndexStr) ? parseInt(zIndexStr, 10) : 1;
    $child.css('zIndex', zIndexNum + zIncrement);
}

function setZIndexForChildren($popup, zIncrementStr) {
    if ($popup && zIncrementStr) {
        var storedZIncrement = $popup.attr('data-uwr-zincrement'),
            zIncrement;
        if (!storedZIncrement) {
            zIncrement = parseInt(zIncrementStr, 10);
            $popup.attr('data-uwr-zincrement', zIncrementStr);
            $popup.find('*').each(function () {
                var $child = $(this);
                $child.attr('data-uwr-saved-zindex', $child.css('zIndex'));
                addZIndex($child, zIncrement);
            });
        }
    }
}

function isWidthDefined($element) {
    var widthDefined = false,
        calculatedWidth;
    if ($element[0].style.width) {
        widthDefined = true;
    } else {
        $element.addClass('uwr-modal-dialog-bogus-width');
        // if calculated width of $element is 2187px, the value defined by CSS class uwr-modal-dialog-bogus-width
        // then we can safely assume, that no width is defined otherwise
        calculatedWidth = $element.css('width');
        if (calculatedWidth !== '2187px') {
            widthDefined = true;
        }
        $element.removeClass('uwr-modal-dialog-bogus-width');
    }
    return widthDefined;
}

function resizeModal($popup) {
    var targetFrame = getState().targetFrame,
        width = frames.innerWidth(targetFrame),
        height = frames.innerHeight(targetFrame),
        bottomPadding = parseInt($popup.css('marginBottom'), 10) + parseInt($popup.css('borderBottomWidth'), 10),
        left,
        $dialog = $popup.find('.uwr-modal-dialog');

    // if width is defined for uwr-modal-dialog element, then extend max width for $popup:
    if (isWidthDefined($dialog)) {
        $popup.addClass('uwr-modal-dialog-popup-enlarged');
    }

    $popup.css('left', '0');
    left = width / 2 - $popup.outerWidth(true) / 2;
    $popup.css({
        'top': 0, // Required for UW5 modal dialogs in UW4 iframes (UBSWI-1932)
        'left': left,
        'z-index': 9999
    });

    $popup.find('.uwr-modal-dialog-content').css('height', '');

    if (height - bottomPadding < $popup.height()) {
        var newHeight = height - ($popup.find('.uwr-modal-dialog-title').outerHeight() +
                $popup.find('.uwr-modal-dialog-actions').outerHeight() + bottomPadding);
        $popup.find('.uwr-modal-dialog-content').height(newHeight + 'px');
    }

    setZIndexForChildren($popup, $popup.css('zIndex'));
}

function restoreZIndexForChildren($popup) {
    if ($popup) {
        var storedZIncrementStr = $popup.attr('data-uwr-zincrement'),
            storedZIncrementNum;
        if (storedZIncrementStr) {
            storedZIncrementNum = parseInt(storedZIncrementStr, 10);
            $popup.find('*').each(function () {
                var $child = $(this);
                var savedZIndex = $child.attr('data-uwr-saved-zindex');
                if (savedZIndex) {
                    $child.css('zIndex', savedZIndex);
                } else {
                    addZIndex($child, (-storedZIncrementNum));
                }
            });
            $popup.removeAttr('data-uwr-zincrement');
        }
    }
}

function getObjectByQualifiedName(name, win) {
    var obj,
        sanitizedName;
    if (name) {
        // remove some characters to prevent others doing eval() tricks
        sanitizedName = name.replace(/[^A-Za-z_0-9\.\[\]\'\"]/g, '');
        /* eslint-disable no-empty */
        try {
            obj = win.eval('window.' + sanitizedName); // eslint-disable-line
        } catch (e) {}
        /* eslint-enable no-empty */
    }
    return obj;
}


/** STATE */

function getState() {
    var targetFrame = getTargetFrameWithoutUwr(),
        state = targetFrame.uwr && targetFrame.uwr.modaldialog && targetFrame.uwr.modaldialog.state;
    if (!state) {
        state = {
            opener: null,
            targetFrame: targetFrame,
            eventTargetElement: null,
            popupDefinition: null,
            hasKeyHandlers: false
        };
        targetFrame.uwr = targetFrame.uwr || {};
        if (!targetFrame.uwr.modaldialog) {
            targetFrame.uwr.modaldialog = {};
        }
        targetFrame.uwr.modaldialog.state = state;
    }
    return state;
}

function initializeState(config) {
    var state = getState();
    state.opener = config.openerWindow;
    state.targetFrame = config.targetFrame;
    state.eventTargetElement = config.eventTargetElement || frames.getDocument(config.openerWindow).body;
}

function destroyState() {
    var targetFrame = getTargetFrameWithoutUwr();
    if (targetFrame.uwr && targetFrame.uwr.modaldialog && targetFrame.uwr.modaldialog.state) {
        targetFrame.uwr.modaldialog.state = null;
    }
}

/** MARKUP PREPARARTION */

export function prepareMarkup(popupDefinition) {
    var content = popupDefinition.innerHTML,
        temp = content
            .replace(/<!--/g, commentStartReplacement)
            .replace(/-->/g, commentEndReplacement);

    // without an extra text IE would retrieve empty string after this call
    popupDefinition.innerHTML = extraText + '<!--' + temp + '-->';
}

function getOriginalMarkupFromPreparedPopupDefinition(preparedPopupDefinition) {
    var content = preparedPopupDefinition.innerHTML,
        inner,
        mainDiv;

    inner = content
        .replace(new RegExp(commentStartReplacement, 'g'), '<!--')
        .replace(new RegExp(commentEndReplacement, 'g'), '-->');
    inner = inner.substring(extraText.length + 4, inner.length - 3);

    mainDiv = preparedPopupDefinition.outerHTML
        .substring(0, preparedPopupDefinition.outerHTML.indexOf(extraText + '<!--'));

    return mainDiv + inner + '</div>';
}

function getOriginalMarkupFromUnpreparedPopupDefinition(unpreparedPopupDefinition) {
    return unpreparedPopupDefinition.outerHTML;
}

export function getOriginalMarkup(popupDefinition) {
    var content = popupDefinition.innerHTML,
        isPrepared = content.indexOf(extraText + '<!--') === 0;

    // For backwards compatibility: if the popup definiton's frame used an older UW4 version
    // that did not prepare the popup definition, we apply a different logic.
    return isPrepared
        ? getOriginalMarkupFromPreparedPopupDefinition(popupDefinition)
        : getOriginalMarkupFromUnpreparedPopupDefinition(popupDefinition);
}

function convertIdAttributes($el) {
    if ($el && $el.attr('id')) {
        $el.attr('data-uwr-id', $el.attr('id'));
        $el.removeAttr('id');
    }
    $el.find('*').each(function () {
        var child = $(this);
        child.attr('data-uwr-id', child.attr('id'));
        child.removeAttr('id');
    });
}

function restoreIdAttributes($el) {
    if ($el && isAccessiblePopupDefinition($el)) {
        if ($el.attr('data-uwr-id')) {
            $el.attr('id', $el.attr('data-uwr-id'));
            $el.removeAttr('data-uwr-id');
        }
        $el.find('*').each(function () {
            var child = $(this);
            child.attr('id', child.attr('data-uwr-id'));
            child.removeAttr('data-uwr-id');
        });
    }
}

/** MODAL BUILDING */

function buildMask($targetBody, $preparedPopupDefinition, targetJQuery) {
    var maskHtml = '<div class="uwr-modal-dialog-mask"></div>',
        $mask = targetJQuery(maskHtml);
    $mask.appendTo($targetBody);
    if ($preparedPopupDefinition.data('close-on-dimmed')) {
        $mask.on('click', function () {
            close();
        });
    }
    return $mask;
}

function buildPopup($targetBody, popupDefinitonHtml, targetJQuery) {
    var $popup = targetJQuery('<div class="uwr-modal-dialog-popup"></div>'),
        oldAjaxCacheState = targetJQuery.ajaxSetup().cache;

    $popup[0].innerHTML = popupDefinitonHtml;
    try {
        targetJQuery.ajaxSetup().cache = true;
        $popup.appendTo($targetBody);
    } finally {
        targetJQuery.ajaxSetup().cache = oldAjaxCacheState;
    }

    return $popup;
}

function finalizeTopButtons($popup) {
    var $popupTitle = $popup.find('.uwr-modal-dialog-title'),
        $titleControl = $popup.find('.uwr-modal-dialog-title .uwr-modal-dialog-title-controls');

    // UW4 compatibility structure conversions
    $popupTitle.wrap('<div class="uwr-modal-dialog-title-bar"></div>');
    $titleControl.detach().appendTo($popup.find('.uwr-modal-dialog-title-bar'));
    $titleControl.find('.uwr-modal-dialog-button-help')
        .addClass('uwr-button uwr-button-small uwr-button-icon uwr-button-icon-right');
}

/** MISC */

function show($mask, $popup) {
    $mask.fadeTo(100, 0.4);
    $popup.fadeIn(100);
    $popup.find('.uwr-modal-dialog').not('.uwr-modal-dialog .uwr-modal-dialog').show();
    $('input:focus, button:focus').blur();
    $popup.focus();
}

function callOnReadyHandler(onReadyHandler, $popup, openerWindow) {
    if (typeof onReadyHandler === 'function') {
        var popupDiv = $popup.find('.uwr-modal-dialog').get(0),
        context = {
            'opener': openerWindow,
            'popup': popupDiv
        };
        onReadyHandler(context);
    }
}

    function isAccessiblePopupDefinition($popupDefinition) {
        var isAccessible = true;
        try {
            $popupDefinition.attr('data-uwr-id');
        } catch (e) {
            isAccessible = false;
        }
        return isAccessible;
    }

/**
 * Clears the content of any iframe.
 *
 * This is to prevent "stolen focus" issue caused by an IE bug where input fields
 * cannot be edited any more after content of iframe had been changed (UBSWI-782).
 */
function clearIframeContent($iframe) {
    $iframe.attr('src', '');
}

function removePopup() {
    var targetFrame = getState().targetFrame,
        $targetBody = $('body', getDocument(targetFrame));

    $('.uwr-modal-dialog-popup', $targetBody).each(function () {
        var $popup = $(this);
        restoreIdAttributes(getState().popupDefinition);
        restoreZIndexForChildren($popup);
        clearIframeContent($popup.find('iframe'));
        $popup.remove();
    });
    $('.uwr-modal-dialog-mask', $targetBody).each(function () {
        $(this).remove();
    });
}

function openInternal(selector, onReadyHandler, targetJQuery, openingTargetFrame) {
    var $preparedPopupDefinition = $(selector),
        popupDefinitonHtml,
        targetFrame = openingTargetFrame || getTargetFrameWithUwr(),
        $targetBody = $('body', getDocument(targetFrame)),
        $mask,
        $popup,
        alreadyOpen = $targetBody.find('.uwr-modal-dialog-mask').length > 0;

    if (!alreadyOpen) {
        popupDefinitonHtml = getOriginalMarkup($preparedPopupDefinition[0]);
        convertIdAttributes($preparedPopupDefinition);

        $mask = buildMask($targetBody, $preparedPopupDefinition, targetJQuery);
        $popup = buildPopup($targetBody, popupDefinitonHtml, targetJQuery);

        getState().popupDefinition = $preparedPopupDefinition;

        finalizeTopButtons($popup);
        addTopCloseButtonHandler($popup);
        addTouchHandler($popup, $mask);
        addMouseWheelHandler($popup, $mask);
        show($mask, $popup);
        addResizeHandler($popup, $mask);
        bindKeyEventHandlers();

        callOnReadyHandler(onReadyHandler, $popup, window);

        // init UWR widgets in the opened modal dialog
        targetFrame.uwr.init();
    }
}

function createIframeHtml(url) {
    return ['<iframe src="',
            url,
            '" class="uwr-modal-dialog-iframe" ',
            ' name="modalDialogContentIframe"',
            'style="z-index:11000;position:fixed;top:0;left:0;width:0;height:0;',
            'background:transparent;border:0;">',
            '</iframe>'].join('');
}

function openAsHtml(config) {
    config.targetFrame = config.targetFrame || getTargetFrameWithUwr();
    config.openerWindow = config.openerWindow || window;

    config.targetFrame.uwr.util.jquery(function (targetJQuery) {
        initializeState(config);
        openInternal(config.selector, config.onReadyHandler, targetJQuery, config.targetFrame);
    });
    fixParentScrolling(getDocument(config.targetFrame).body);
}

/**
 * Opens a modal dialog page in an iframe. If the selector is set, then the according Modal Dialog will
 * be opened.
 *
 * @param config The configuration object described at the open function.
 */
function openAsIframe(config) {
    var modalSelector = config.selector || '.uwr-modal-dialog',
        targetFrame = getTargetFrameWithoutUwr(),
        openerWindow = window,
        $targetBody = $('body', getDocument(targetFrame)),
        $iframe,
        iframeElement;

    $iframe = $('iframe.uwr-modal-dialog-iframe', $targetBody);
    if ($iframe.length === 0) {
        $iframe = $(createIframeHtml(config.frameUrl));
        $targetBody.append($iframe);
    }

    iframeElement = $iframe.get(0);

    iframeElement.onload = function iframeOnloadHandler() {
        var frameWindow = iframeElement.contentWindow;
        frameWindow.uwr.ready(function () {
            frameWindow.uwr.modaldialog.open({
                selector: modalSelector,
                onReadyHandler: config.onReadyHandler,
                targetFrame: frameWindow,
                openerWindow: openerWindow
            });
            fixParentScrolling($targetBody.get(0));
            // Fix IE blinking
            $iframe.css('width', '100%');
            $iframe.css('height', '100%');
            iframeElement.onload = undefined; // Prevent second onload on clearIframeContent
        });
    };
}

function fixParentScrolling(targetBody) {
    var state = getState(),
        $targetBody = $(targetBody),
        body = $targetBody[0],
        origClientHeight = body.clientHeight,
        origClientWidth = body.clientWidth,
        fixedMarginRight,
        fixedMarginTop,
        marginTop;

    // store original styles then hide body scrollbars
    // separate properties for backwards compatibility
    if (!$targetBody.find('.uwr-modal-dialog-iframe').length) {
        state.noScrollBody = targetBody;

        state.marginRight = $targetBody.css('margin-right');
        state.marginTop = $targetBody.css('margin-top');
        state.overflowX = $targetBody.css('overflow-x');
        state.overflowY = $targetBody.css('overflow-y');

        $targetBody.css('overflow-x', 'hidden');
        $targetBody.css('overflow-y', 'hidden');
    } else {
        state.iframeNoScrollBody = targetBody;

        state.oldIframeStyleRules = {
                marginRight: $targetBody.css('margin-right'),
                marginTop: $targetBody.css('margin-top'),
                overflowX: $targetBody.css('overflow-x'),
                overflowY: $targetBody.css('overflow-y')
            };

        $targetBody.css('overflow-x', 'hidden');
        $targetBody.css('overflow-y', 'hidden');
    }

    // fix body's right margin by using body client width increment to prevent page re-wrapping
    fixedMarginRight = parseInt(state.marginRight, 10) + (body.clientWidth - origClientWidth);
    $targetBody.css('margin-right', fixedMarginRight);

    // fix body's top margin by using the body client height increment to prevent page jumping
    marginTop = parseInt(state.marginTop, 10);
    fixedMarginTop = marginTop - (body.clientHeight - origClientHeight);

    // fix top margin only when original value is less than scrollbar increment
    if (fixedMarginTop < 0) {
        fixedMarginTop = marginTop < 0 ? marginTop : 0;
    }

    $targetBody.css('margin-top', fixedMarginTop);
}

function restoreParentScrolling() {
    var state = getState(),
        $iframeBody = $(state.iframeNoScrollBody),
        $targetBody = $(state.noScrollBody),
        restoreProperties = ['overflow', 'overflowX', 'overflowY', 'marginTop', 'marginRight'],
        styleProperty,
        i, l;

    if (!state) { return; }
    if (!$targetBody.length) {
        $targetBody = $('body', getTargetFrameWithUwr().document);
    }

    for (i = 0, l = restoreProperties.length; i < l; i++) {
        styleProperty = restoreProperties[i];
        if (state[styleProperty]) {
            $targetBody.css(styleProperty, state[styleProperty]);
        }
    }

    if (state.oldIframeStyleRules) {
        $iframeBody.css(state.oldIframeStyleRules);
    }
}

function closeIframe() {
    var targetFrame = getTargetFrameWithoutUwr(),
        $targetBody = $('body', getDocument(targetFrame)),
        $iframe = $('.uwr-modal-dialog-iframe', $targetBody);
    if ($iframe.length > 0) {
        clearIframeContent($iframe);
        $iframe.remove();
    }
}

function cleanupAfterClose() {
    dispatchCustomCloseEvent();
    destroyState();
    closeIframe();
}

/**
 * Initializes all modal dialogs on the page. Basically binds key press handlers to the top window.
 * It is called by the framework once with no parameters, on page load. Should be called by client
 * apps only if they inject popup definitions dynamically.
 *
 * init() is an asynchronous call, so if some logic needs to be added once init() is finished, a callback
 * function can be passed in as a parameter.
 *
 * @param callback A Javascript function object that will be called at the end of the init() call.
 */
export function init(callback) {
    common.invoke(callback);
}

/**
 * Opens a modal dialog defined by the given CSS selector.
 *
 * The API is changed in a backward compatible way to support iframe based Modal Dialogs. Please,
 * use the recommended open(config) call style instead of the open(selector, onReadyHandler).
 *
 * The config object can have more parameters:
 * - frameUrl:           If this is set, then the Modal Dialog will be opened in a separated iframe. This
 *                       is the recommended usage in an iframe environment like workbenches.
 * - selector:           The CSS selector of the popup. If not set and only one Modal Dialog definition
 *                       is placed in the page, then this will be used. If there are multiple definitions
 *                       on a page, but this is not set, then the same result of different calls is not
 *                       guaranteed.
 * - onReadyHandler:     The callback function what can modify the content of the Modal Dialog when it is
 *                       ready for that.
 * - eventTargetElement: The HTML element which calls the open (what the click listener is registered to).
 *                       This is necessary to the custom events dispatching, the event will be dispatched
 *                       using the HTML element registered here. Using the 'this' is recommended.
 *
 * @param configOrSelector A config object to set up the Modal Dialog opening or a CSS selector string
 *        that points to the Modal Dialog which should be open. Please, use the config instead of the
 *        selector string. Selector string is deprecated.
 * @param onReadyHandler Optional, deprecated. A function which is called after the Modal Dialog is
 *        opened but before the content is initialized. Please, use the config instead of that.
 */
export function open(configOrSelector, onReadyHandler) {
    if (typeof configOrSelector === 'object') {
        if (configOrSelector.frameUrl) {
            openAsIframe(configOrSelector);
        } else {
            openAsHtml(configOrSelector);
        }
    } else {
        openAsHtml({selector: configOrSelector, onReadyHandler: onReadyHandler});
    }
}

/**
 * Closes the actual visible modal dialog.
 */
export function close() {
    removePopup();
    restoreParentScrolling();
    unbindKeyEventHandlers();
    setTimeout(cleanupAfterClose, 0); // Event Loop solution
}

/**
 * Invokes a function from the modal dialog. The function must be defined in the frame that opens
 * the modal dialog. Within the function the 'this' will reference an object with the below fields:
 * this.opener: the opener window frame, this.popup: the visible popup's main DOM element.
 *
 * The 1st argument is the name of the above function, the other arguments are the normal arguments of it.
 *
 * E.g.: invoke('resetForm', true, 23); in the modal dialog will call resetForm(true, 23); in the
 * opener frame.
 */
export function invoke() {
    var state = getState(),
        $target = $(getDocument(state.targetFrame)),
        $popup = $('.uwr-modal-dialog-popup', $target),

        args = Array.prototype.slice.call(arguments, 0),
        functionName = args[0],
        functionArgs = args.slice(1, args.length),
        func = getObjectByQualifiedName(functionName, state.opener),

        // this object will be passed to the function as 'this'
        context = {
            'opener': state.opener,
            'popup': $popup.get(0)
        };

    if (func) {
        func.apply(context, functionArgs);
    }
}

export function prepare(callback) {
    // wait till the page is ready
    $(function () {
        $('.uwr-modal-dialog').each(function (i, el) {
            prepareMarkup(el);
        });
        common.invoke(callback);
    });
}



//////////////////
// WEBPACK FOOTER
// ./widgets/ModalDialog/js/modalDialog.js
// module id = 34
// module chunks = main